export enum BusinessRelationNaturalPartyVersionIdEnum {
    Driver = 'Driver',
    Witness = 'Witness',
    Contact = 'Contact',
    CoInsured = 'CoInsured',
    Reporter = 'Reporter',
    Counterparty = 'Counterparty',
    Normal = 'Normal',
}
